import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { logEvent } from 'firebase/analytics';
import { getPerformance } from 'firebase/performance';
import { AnalyticsHandler } from '@solidgroup-agency/ui-shared-components';
import {
  FIREBASE_ANALYTICS,
  FIREBASE_APP,
  PERFORMANCE_REQUIRES_CONSENT,
} from './firebase.config';

@Injectable({
  providedIn: 'root',
})
export class FirebaseAnalyticsHandler implements AnalyticsHandler {
  private analytics = inject(FIREBASE_ANALYTICS, { optional: true });
  private app = inject(FIREBASE_APP, { optional: true });
  private platformId = inject(PLATFORM_ID);
  private performanceRequiresConsent =
    inject(PERFORMANCE_REQUIRES_CONSENT, { optional: true }) ?? false;
  private isEnabled = false;
  private performanceBooted = false;

  enableAnalytics(): void {
    this.isEnabled = true;
    this.bootPerformanceIfGated();
  }

  disableAnalytics(): void {
    this.isEnabled = false;
    // Firebase Performance has no public teardown — once booted in a tab it
    // keeps reporting until reload. Datenschutzerklärung weist darauf hin.
  }

  logCustomEvent(
    eventName: string,
    eventParams?: Record<string, unknown>,
  ): void {
    if (
      this.analytics &&
      this.isEnabled &&
      isPlatformBrowser(this.platformId)
    ) {
      logEvent(this.analytics, eventName, eventParams);
    }
  }

  logPageView(pagePath: string, pageTitle: string): void {
    if (
      this.analytics &&
      this.isEnabled &&
      isPlatformBrowser(this.platformId)
    ) {
      logEvent(this.analytics, 'page_view', {
        page_path: pagePath,
        page_title: pageTitle,
      });
    }
  }

  private bootPerformanceIfGated(): void {
    if (!this.performanceRequiresConsent) return;
    if (this.performanceBooted) return;
    if (!isPlatformBrowser(this.platformId)) return;
    try {
      if (!this.app) return;
      getPerformance(this.app);
      this.performanceBooted = true;
    } catch (error) {
      console.warn('Failed to start Performance Monitoring:', error);
    }
  }
}
